import { useEffect, useState } from 'react'
import { useQuickKeysManager, useRegisterManager } from '../../ng-compat/hooks'
import { quickKeyLayoutsStore } from '../../factories/database/quick-key-layouts-store'
import { buildQuickKeysLayout } from './utils/qk-layout'
import { ApiLayoutData, QuickKeyRoot } from './utils/qk-types'

const useApiLayout = () => {
  const quickKeysManager = useQuickKeysManager()
  const registerManager = useRegisterManager()
  const [data, setData] = useState<ApiLayoutData | null>(null)

  const layoutId = registerManager.getActiveRegister()?.button_layout_id

  useEffect(() => {
    const fetchApiLayout = async () => {
      if (layoutId) {
        const newData = await quickKeyLayoutsStore.get(layoutId)
        setData(newData as ApiLayoutData)
      } else {
        setData(null)
      }
    }
    fetchApiLayout()

    quickKeysManager.on('quickKeyLayoutChange', fetchApiLayout)

    return () => {
      quickKeysManager.off('quickKeyLayoutChange', fetchApiLayout)
    }
  }, [layoutId, quickKeysManager, registerManager])

  return data
}

export const useQuickKeysLayout = () => {
  const data = useApiLayout()
  const [layout, setLayout] = useState<QuickKeyRoot | null>(null)

  useEffect(() => {
    const set = () => {
      if (data) {
        const newLayout = buildQuickKeysLayout(data)
        setLayout(newLayout)
      } else {
        setLayout(null)
      }
    }

    set()
  }, [data])

  return layout
}
